/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.doctor')
    .component('doctorform', {
      restrict: 'E',
      bindings: {
        doctor: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcutils/doctor/doctorform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'DoctorHelper',
        function ($log, DoctorHelper) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          vm.zipsave = zipsave;

          vm.$onInit = function () {
            vm.lastdoctor = angular.copy(vm.doctor);
          };

          function save() {
            if (!angular.equals(vm.doctor, vm.lastdoctor)) {
              vm.doctor.fname = DoctorHelper.fname(vm.doctor);
              vm.lastdoctor = angular.copy(vm.doctor);
              vm.parentsave({doctor: vm.doctor});
            }
          }

          function cancel() {
            vm.doctor = angular.copy(vm.lastdoctor);
            vm.oncancel();
          }

          function zipsave(zip, city) {
            // $log.debug('debug: doctorform zipsave called: ', zip, city);
            vm.doctor.postcode = zip;
            vm.doctor.city = city;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());